import { Component } from '@angular/core';

interface ValueWithLabel {
  label: string;
  value: string | number;
}

interface InvoiceItem {
  description: string;
  quantity: number;
  unit_price: number;
  total_price: number;
  currency?: string;
}

interface InvoiceDetails {
  buyer_name: ValueWithLabel;
  buyer_address: ValueWithLabel;
  buyer_email: ValueWithLabel;
  vendor_name: ValueWithLabel;
  vendor_address: ValueWithLabel;
  vendor_phone: ValueWithLabel;
  vendor_email: ValueWithLabel;
  invoice_number: ValueWithLabel;
  date: ValueWithLabel;
  due_date: ValueWithLabel;
  tax_id: ValueWithLabel;
  sub_total: ValueWithLabel & { currency?: string };
  vat: ValueWithLabel & { currency?: string };
  total_amount: ValueWithLabel & { currency?: string };
  haqtza: ValueWithLabel;
  print_date: ValueWithLabel;
  items: InvoiceItem[];
}

@Component({
  selector: 'app-invoice-plus-table',
  templateUrl: './invoice-plus-table.component.html',
  styleUrls: ['./invoice-plus-table.component.css'],
})
export class InvoicePlusTableComponent {
  invoiceData: InvoiceDetails | null = null;

  displayTable(body: any) {
    if (body?.ocr_plus_data) {
      this.invoiceData = {
        ...body.ocr_plus_data,
        items: body.ocr_plus_data.items || [],
      };
    }
  }
}
